export const KEY_DATES_TYPE = [
  {
    groupName: 'tradeDateGroup',
    groupTitle: 'Trade Date',
    key: 'tradeDate',
    hidden: false,
  },
  {
    groupName: 'productFinalisationDate',
    groupTitle: 'Product Finalisation Date',
    key: 'productFinalisationDate',
    hidden: false,
  },
  {
    groupName: 'initialObservationDate',
    groupTitle: 'Initial Observation Date',
    key: 'initialObs',
    hidden: false,
  },
  {
    groupName: 'issueDate',
    groupTitle: 'Issue Date',
    key: 'issueDate',
    hidden: false,
  },
  {
    groupName: 'interestStartDate',
    groupTitle: 'Interest Start Date',
    key: 'interestStartDate',
    hidden: false,
  },
  {
    groupName: 'interestEndDate',
    groupTitle: 'Interest End Date',
    key: 'interestEndDate',
    hidden: false,
  },
  {
    groupName: 'finalObservationDate',
    groupTitle: 'Final Observation Date',
    key: 'finalObs',
    hidden: false,
  },
  {
    groupName: 'redemptionDateGroup',
    groupTitle: 'Redemption Date',
    key: 'redemption',
    hidden: false,
  },
];

export interface KeyDate {
  id: string;
  displayValue: string;
  disabled?: boolean | undefined;
}

export interface KeyDateToResolve {
  priority: string;
  value: string;
  relative?: RelativePayload;
}

export interface KeyDateSchedulerPayload {
  issueDate: KeyDateToResolve;
  interestStartDate: KeyDateToResolve;
  interestEndDate: KeyDateToResolve;
  maturityDate: KeyDateToResolve;
  initialFixingDate: KeyDateToResolve;
  finalFixingDate: KeyDateToResolve;
  tradeDate: KeyDateToResolve;
  productFinalisationDate: KeyDateToResolve;
}

export interface RelativePayload {
  rollConvention: string;
  anchorDate: string;
  offset: string;
  holidays: string[] | [];
  nonWeekDays: string[] | [];
}

export type KeyDates = KeyDate[];

export type RowName =
  | 'initialObservationDate'
  | 'issueDate'
  | 'finalObservationDate'
  | 'redemptionDateGroup'
  | 'tradeDateGroup'
  | 'productFinalisationDate';

export type RowTitle =
  | 'Initial Observation Date'
  | 'Issue Date'
  | 'Final Observation Date'
  | 'Redemption Date'
  | 'Trade Date'
  | 'Product Finalisation Date';

export type RowKey =
  | 'initialObs'
  | 'issueDate'
  | 'finalObs'
  | 'redemption'
  | 'tradeDate'
  | 'productFinalisationDate';
